import {
    KentRecordType,
    KentRecordSubType
} from "./KentRecordTypes";

import {
    IRecordTypeFeatureInfoClick,
    RecordTypeResource,
    IRecordTypeHeading,    
    IMappingTextPack
} from "@esdm/map";
import { ILayerGroup } from "@esdm/map/dist/layers/groups/ILayerGroup";


let headingConfiguration = (): Array<IRecordTypeHeading> => {
    let items = new Array<IRecordTypeHeading>();

    items.push({
        recordTypeCode: KentRecordType.Monument,
        recordSubTypeCode: null,
        heading: "Monuments"
    });

    items.push({
        recordTypeCode: KentRecordType.Designation,
        recordSubTypeCode: null,
        heading: "Designations"
    });

    items.push({
        recordTypeCode: KentRecordType.Designation,
        recordSubTypeCode: KentRecordSubType.ScheduledMonument,
        heading: "Scheduled Monuments"
    }); 

    items.push({
        recordTypeCode: KentRecordType.Designation,
        recordSubTypeCode: KentRecordSubType.RegisteredParksAndGardens,
        heading: "Registered Parks and Gardens"
    });


    items.push({
        recordTypeCode: KentRecordType.Designation,
        recordSubTypeCode: KentRecordSubType.HistoricParksAndGardens,
        heading: "Historic Parks and Gardens"
    });

    items.push({
        recordTypeCode: KentRecordType.Designation,
        recordSubTypeCode: KentRecordSubType.ConservationArea,
        heading: "Conservation Areas"
    });  

    items.push({
        recordTypeCode: KentRecordType.DoverCharacterisation,
        recordSubTypeCode: KentRecordSubType.AngloSaxon,
        heading: "Dover UAD - Anglo Saxon"
    });  

    items.push({
        recordTypeCode: KentRecordType.DoverCharacterisation,
        recordSubTypeCode: KentRecordSubType.EarlyRoman,
        heading: "Dover UAD - Early Roman"
    }); 

    items.push({
        recordTypeCode: KentRecordType.DoverCharacterisation,
        recordSubTypeCode: KentRecordSubType.LateRoman,
        heading: "Dover UAD - Late Roman"
    }); 

    items.push({
        recordTypeCode: KentRecordType.DoverCharacterisation,
        recordSubTypeCode: KentRecordSubType.Harbour1500,
        heading: "Dover UAD - Harbour up to 1500"
    }); 

    items.push({
        recordTypeCode: KentRecordType.DoverCharacterisation,
        recordSubTypeCode: KentRecordSubType.Medieval,
        heading: "Dover UAD - Medieval"
    }); 

    items.push({
        recordTypeCode: KentRecordType.DoverCharacterisation,
        recordSubTypeCode: KentRecordSubType.PostMedieval1638to1641,
        heading: "Dover UAD - Post-Medieval 1638 to 1641 "
    }); 

    items.push({
        recordTypeCode: KentRecordType.DoverCharacterisation,
        recordSubTypeCode: KentRecordSubType.PostMedieval1865,
        heading: "Dover UAD - Post-Medieval 1865"
    }); 

    items.push({
        recordTypeCode: KentRecordType.DoverCharacterisation,
        recordSubTypeCode: KentRecordSubType.PostMedieval1908,
        heading: "Dover UAD - Post-Medieval 1908"
    }); 

    items.push({
        recordTypeCode: KentRecordType.HistoricLandscapeCharacterisation,
        recordSubTypeCode: null,
        heading: "Historic Landscape Characterisation"
    }); 
    
    return items;
}

export class HbsmrRecordTypeResource extends RecordTypeResource {

    public constructor(
        private _mappingTextPack: IMappingTextPack,
    ) {
        super(headingConfiguration());
    }
    
    public groupByRecordSubTypeCode(recordTypeCode: string): boolean 
    {
        return (recordTypeCode.toLowerCase() === KentRecordType.Designation);        
    }      

    public mapToIRecordTypeInfoClick(featureProperties: any, layerGroup: ILayerGroup): IRecordTypeFeatureInfoClick 
    {
        /** Override info values for Conservation Areas **/
        if (layerGroup.layerSubType == KentRecordSubType.ConservationArea)
            return {
                id: featureProperties.UID,
                uid: featureProperties.UID,
                ref: featureProperties.UID,
                name: featureProperties.CA_NAME,
                recordType: KentRecordType.Designation,
                recordSubType: "Conservation Area",
                recordSubTypeCode: KentRecordSubType.ConservationArea,
                data: featureProperties,
                heading: this.getHeading(KentRecordType.Designation, KentRecordSubType.ConservationArea),
                layerGroup: layerGroup
            }
        else if (layerGroup.layerType == KentRecordType.DoverCharacterisation)
            return {
                id: featureProperties.ID_UAD,
                uid: featureProperties.ID_UAD,
                ref: featureProperties.Type,
                name: featureProperties.Name,
                recordType: KentRecordType.DoverCharacterisation,
                recordSubType: layerGroup.layerSubType,
                recordSubTypeCode: layerGroup.layerSubType,
                data: featureProperties,
                heading: this.getHeading(KentRecordType.DoverCharacterisation, layerGroup.layerSubType),
                layerGroup: layerGroup
            }
        else if (layerGroup.layerType == KentRecordType.HistoricLandscapeCharacterisation)
            return {
                id: featureProperties.INDEX,
                uid: featureProperties.INDEX,
                ref: featureProperties.NEW_TYPE,
                name: featureProperties.TEXT,
                recordType: KentRecordType.HistoricLandscapeCharacterisation,
                recordSubType: null,
                recordSubTypeCode: null,
                data: featureProperties,
                heading: this.getHeading(KentRecordType.HistoricLandscapeCharacterisation, null),
                layerGroup: layerGroup
            }
        else {
            return {
                id: featureProperties.id,
                uid: featureProperties.uid,
                ref: featureProperties.ref,
                name: featureProperties.name,
                recordType: featureProperties.rectype,
                recordSubType: featureProperties.recsubtype,
                recordSubTypeCode: featureProperties.recsubtypecode,
                data: featureProperties,
                heading: this.getHeading(featureProperties.rectype, featureProperties.recsubtypecode),
                layerGroup: layerGroup
            }
        }
    }

    public getInfoClickHtmlTemplate(recordTypeInfoClick: IRecordTypeFeatureInfoClick): string 
    {
        let html: string = "";
        let featurePropertyNameForId = "uid";
        let layerType: string = recordTypeInfoClick.layerGroup.layerType;

        if (recordTypeInfoClick.recordSubTypeCode == "COA") {
            html = `
                         <li>
                            <span>[CA_NAME]<br />Designation date: [CA_DATE]</span>
                         </li>`;
        } else if (recordTypeInfoClick.recordType == "dc")
            html = `
                         <li>
                            <a href="[Full_Text]" target="_blank" title="Go to Dover UAD project (in new tab/window)"><span>[Name]<br />Type: [Type]</span></a>
                         </li>`;
        else if (recordTypeInfoClick.recordType == "hlc")
            html = `
                         <li>
                            <a href="[Hyperlink]" target="_blank" title="Go to Kent HLC project (in new tab/window)"><span>[HLTypeText]<br />Type: [NEW_TYPE] [TEXT]</span></a>
                         </li>`;
        else {
            //add controller (or any arbitrary data) to the data object
            switch (recordTypeInfoClick.recordType.toLowerCase()) {
                case "mon":
                    recordTypeInfoClick.data.controller = "Monument";
                    break;
                case "event":
                    recordTypeInfoClick.data.controller = "Event";
                    break;
                case "desig":
                    recordTypeInfoClick.data.controller = "Designation";
                    break;
            }

            html = `
                         <li>
                            <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}"><span><i class="far fa-info-circle" aria-hidden="true"></i></span></a>
                            &nbsp;
                            <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}">                               
                                <span>[name]</span>               
                            </a>
                            <a class="showOnMap" title="${this._mappingTextPack.centreOnMap}" data-recordtype="${layerType}" data-id="[id]">                                                
                                <i class="far fa-map-marked-alt fa-lg" aria-hidden="true"></i>
                            </a>
                         </li>`;
        }
        return html;
    }

    
}